export default "__VITE_ASSET__liB8qlyc__"